// extracted by mini-css-extract-plugin
export default {"text":"VerifyDetails__text--Vy4","btnWrap":"VerifyDetails__btnWrap--2JS","btn":"VerifyDetails__btn--3wa"};